(() => {
  'use strict';
  const key = 'postbus-favorites-v1';
  const promptKey = 'postbus-favorite-invitation-v1';
  const limit = 100;
  const dialog = () => document.querySelector('.pb26-favorites');
  const prompt = () => document.querySelector('[data-pb44-save-prompt]');
  const config = () => document.querySelector('[data-pb44-favorites-config]')?.dataset || {};
  const handlesPattern = /^[a-z0-9][a-z0-9-]{0,199}$/;
  const openers = new WeakMap();
  let shared = null;
  let shareLoad = 0;
  let promptSeen = false;
  let saveStatusTimer;
  function safeImage(value) {
    if (typeof value !== 'string' || !value) return '';
    try {
      const url = new URL(value, location.origin);
      return url.protocol === 'https:' && (url.origin === location.origin || url.hostname === 'cdn.shopify.com' || url.hostname.endsWith('.shopify.com')) ? url.href : '';
    } catch (_) { return ''; }
  }
  function readSaved(value) {
    try {
      const parsed = JSON.parse(value || '[]');
      if (!Array.isArray(parsed)) return [];
      const seen = new Set();
      return parsed.slice(0, limit).flatMap(item => {
        if (!item || typeof item.handle !== 'string' || !handlesPattern.test(item.handle) || typeof item.title !== 'string' || !item.title.trim() || typeof item.url !== 'string' || seen.has(item.handle)) return [];
        try {
          const url = new URL(item.url, location.origin);
          if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9][a-z0-9-]*\/?$/i.test(url.pathname)) return [];
          const urlHandle = url.pathname.replace(/\/$/, '').split('/').pop();
          if (urlHandle !== item.handle) return [];
          seen.add(item.handle);
          const images = Array.isArray(item.images) ? item.images.slice(0, 3).map(safeImage).filter(Boolean) : [];
          const image = item.handle.startsWith('postbus-jul-paket-') && !images.length ? '' : safeImage(item.image);
          return [{handle: item.handle, title: item.title.trim().slice(0, 300), url: url.pathname, image, images}];
        } catch (_) { return []; }
      });
    } catch (_) { return []; }
  }
  let saved = [];
  try {
    saved = readSaved(localStorage.getItem(key));
    promptSeen = Number(localStorage.getItem(promptKey)) > Date.now() - 30 * 86400000;
  } catch (_) {}
  function persist() {
    try {
      localStorage.setItem(key, JSON.stringify(saved));
      return true;
    } catch (_) { return false; }
  }
  function announce(message) {
    const status = document.querySelector('[data-pb44-save-status]');
    if (!status) return;
    status.textContent = '';
    clearTimeout(saveStatusTimer);
    saveStatusTimer = setTimeout(() => { status.textContent = message; }, 30);
  }
  function setStatus(message) {
    const status = dialog()?.querySelector('[data-pb26-favorites-status]');
    if (status) status.textContent = message || '';
  }
  function imageFor(item, width, height) {
    if (item.images?.length) {
      const group = document.createElement('span');
      group.className = 'pb44-favorite-art';
      group.dataset.count = String(item.images.length);
      item.images.forEach(source => {
        const image = document.createElement('img');
        image.src = source;
        image.alt = '';
        image.loading = 'lazy';
        image.width = width;
        image.height = height;
        group.append(image);
      });
      return group;
    }
    if (!item.image) return null;
    const image = document.createElement('img');
    image.src = item.image;
    image.alt = '';
    image.loading = 'lazy';
    image.width = width;
    image.height = height;
    return image;
  }
  function show(element, opener) {
    if (!element || element.open) return;
    openers.set(element, opener || document.activeElement);
    element.showModal();
  }
  function close(element) {
    if (!element?.open) return;
    element.close();
  }
  function refresh() {
    const data = config();
    document.querySelectorAll('[data-pb26-save]').forEach(button => {
      const selected = saved.some(item => item.handle === button.dataset.handle);
      if (selected && button.dataset.images) {
        try {
          const index = saved.findIndex(item => item.handle === button.dataset.handle);
          const images = JSON.parse(button.dataset.images);
          const updated = readSaved(JSON.stringify([{...saved[index], images}]))[0];
          if (updated && JSON.stringify(updated.images) !== JSON.stringify(saved[index].images)) {
            saved[index] = updated;
            persist();
          }
        } catch (_) {}
      }
      button.setAttribute('aria-pressed', String(selected));
      const label = selected ? data.removeLabel : data.saveLabel;
      if (label) button.setAttribute('aria-label', label.replace('__TITLE__', button.dataset.title || ''));
    });
    document.querySelectorAll('[data-pb44-favorites-count]').forEach(node => { node.textContent = String(saved.length); });
    document.querySelectorAll('[data-pb26-favorites]').forEach(button => {
      if (data.countLabel) button.setAttribute('aria-label', data.countLabel.replace('__COUNT__', String(saved.length)));
    });
    const current = dialog();
    if (!current) return;
    const list = current.querySelector('[data-pb26-favorites-list]');
    if (!list) return;
    const items = shared || saved;
    list.replaceChildren();
    items.forEach(item => {
      const row = document.createElement('div');
      row.className = 'pb26-favorite';
      const link = document.createElement('a');
      link.href = item.url;
      const image = imageFor(item, 300, 375);
      if (image) link.append(image);
      const title = document.createElement('span');
      title.textContent = item.title;
      const price = document.createElement('small');
      price.textContent = current.dataset.priceLabel;
      link.append(title, price);
      row.append(link);
      if (shared === null) {
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'pb26-favorite__remove';
        remove.dataset.pb26Remove = item.handle;
        remove.textContent = current.dataset.removeButton;
        remove.setAttribute('aria-label', (current.dataset.removeLabel || '').replace('__TITLE__', item.title));
        row.append(remove);
      }
      list.append(row);
    });
    const empty = current.querySelector('[data-pb26-favorites-empty]');
    if (empty) empty.hidden = items.length > 0 || shared !== null;
    const shareControls = current.querySelector('[data-pb44-share-controls]');
    if (shareControls) shareControls.hidden = !items.length || shared !== null;
    const sharedControls = current.querySelector('[data-pb44-shared-controls]');
    if (sharedControls) sharedControls.hidden = shared === null;
    const saveSelection = current.querySelector('[data-pb44-share-save]');
    if (saveSelection) saveSelection.disabled = !shared?.length;
    const count = current.querySelector('[data-pb44-favorites-count]');
    if (count) count.textContent = String(items.length);
  }
  function invite(item, opener) {
    const current = prompt();
    if (!current || promptSeen || config().signedIn === 'true' || document.querySelector('dialog[open]')) return;
    promptSeen = true;
    try { localStorage.setItem(promptKey, String(Date.now())); } catch (_) {}
    const product = current.querySelector('[data-pb44-prompt-product]');
    if (product) {
      product.replaceChildren();
      const image = imageFor(item, 56, 72);
      if (image) product.append(image);
      const title = document.createElement('span');
      title.textContent = item.title;
      product.append(title);
    }
    show(current, opener);
  }
  async function copySelection() {
    const url = new URL(config().shareUrl || '/', location.origin);
    url.hash = 'favoriter=' + saved.map(item => item.handle).join(',');
    try {
      if (!navigator.clipboard?.writeText) throw new Error('clipboard-unavailable');
      await navigator.clipboard.writeText(url.href);
      setStatus(config().shareCopied);
    } catch (_) {
      const fallback = dialog()?.querySelector('[data-pb44-share-fallback]');
      const input = dialog()?.querySelector('[data-pb44-share-input]');
      if (fallback && input) {
        fallback.hidden = false;
        input.value = url.href;
        input.focus();
        input.select();
      }
    }
  }
  async function loadSelection() {
    if (!location.hash.startsWith('#favoriter=')) return;
    let handles;
    try { handles = [...new Set(decodeURIComponent(location.hash.slice(11)).split(','))].filter(handle => handlesPattern.test(handle)).slice(0, limit); } catch (_) { return; }
    if (!handles.length) return;
    const request = ++shareLoad;
    shared = [];
    refresh();
    setStatus(config().shareLoading);
    show(dialog());
    const items = [];
    for (let start = 0; start < handles.length; start += 4) {
      const batch = await Promise.all(handles.slice(start, start + 4).map(async handle => {
        try {
          const response = await fetch('/products/' + encodeURIComponent(handle) + '.js', {headers: {Accept: 'application/json'}, credentials: 'same-origin'});
          if (!response.ok) return null;
          const product = await response.json();
          let images = [];
          if (handle.startsWith('postbus-jul-paket-')) {
            const description = new DOMParser().parseFromString(product.description || '', 'text/html');
            const componentHandles = [...description.querySelectorAll('a[href]')].flatMap(link => {
              try {
                const url = new URL(link.getAttribute('href'), location.origin);
                const component = url.pathname.replace(/\/$/, '').split('/').pop();
                return url.origin === location.origin && url.pathname.startsWith('/products/') && handlesPattern.test(component) && component !== handle ? [component] : [];
              } catch (_) { return []; }
            });
            images = (await Promise.all([...new Set(componentHandles)].slice(0, 3).map(async component => {
              try {
                const result = await fetch('/products/' + component + '.js', {headers: {Accept: 'application/json'}, credentials: 'same-origin'});
                if (!result.ok) return '';
                const item = await result.json();
                const original = item.media?.find(media => /originalmotiv|utan ram/i.test(media.alt || ''));
                const source = original?.preview_image?.src || item.images?.find(image => /original\.(png|jpe?g|webp)/i.test(image));
                return safeImage(source);
              } catch (_) { return ''; }
            }))).filter(Boolean);
          }
          return readSaved(JSON.stringify([{handle: product.handle, title: product.title, url: '/products/' + product.handle, image: product.featured_image || product.images?.[0] || '', images}]))[0] || null;
        } catch (_) { return null; }
      }));
      if (request !== shareLoad) return;
      items.push(...batch.filter(Boolean));
    }
    shared = items;
    refresh();
    setStatus(items.length === handles.length ? '' : config().shareError);
  }
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const save = event.target.closest('[data-pb26-save]');
    if (save) {
      event.preventDefault();
      let images = [];
      try { images = JSON.parse(save.dataset.images || '[]'); } catch (_) {}
      const item = readSaved(JSON.stringify([{handle: save.dataset.handle, title: save.dataset.title, url: save.dataset.url, image: save.dataset.image, images}]))[0];
      if (!item) return;
      const index = saved.findIndex(entry => entry.handle === item.handle);
      if (index < 0 && saved.length >= limit) {
        announce(config().saveLimit);
        return;
      }
      if (index >= 0) saved.splice(index, 1);
      else saved.push(item);
      const persisted = persist();
      refresh();
      const label = index >= 0 ? dialog()?.dataset.removedLabel : config().savedLabel;
      announce(persisted ? (label || '').replace('__TITLE__', item.title) : config().storageError);
      if (persisted && index < 0) invite(item, save);
      return;
    }
    const remove = event.target.closest('[data-pb26-remove]');
    if (remove) {
      const index = saved.findIndex(item => item.handle === remove.dataset.pb26Remove);
      if (index >= 0) {
        const [item] = saved.splice(index, 1);
        const persisted = persist();
        refresh();
        setStatus(persisted ? (dialog()?.dataset.removedLabel || '').replace('__TITLE__', item.title) : config().storageError);
        const next = dialog()?.querySelectorAll('[data-pb26-remove]');
        (next?.[Math.min(index, next.length - 1)] || dialog()?.querySelector('[data-pb26-close]'))?.focus();
      }
      return;
    }
    const opener = event.target.closest('[data-pb26-favorites]');
    if (opener) {
      event.preventDefault();
      shared = null;
      shareLoad++;
      refresh();
      setStatus('');
      show(dialog(), opener);
    }
    if (event.target.closest('[data-pb26-close]')) close(dialog());
    if (event.target.closest('[data-pb44-prompt-close]')) close(prompt());
    if (event.target.closest('[data-pb44-prompt-favorites]')) {
      const opener = openers.get(prompt());
      close(prompt());
      shared = null;
      refresh();
      setStatus('');
      show(dialog(), opener);
    }
    if (event.target.closest('[data-pb44-share]')) copySelection();
    if (event.target.closest('[data-pb44-share-save]') && shared?.length) {
      const imported = new Map(saved.map(item => [item.handle, item]));
      let overflow = false;
      shared.forEach(item => {
        if (imported.has(item.handle) || imported.size < limit) imported.set(item.handle, item);
        else overflow = true;
      });
      saved = [...imported.values()];
      const persisted = persist();
      shared = null;
      refresh();
      setStatus(persisted ? (overflow ? config().shareLimit : config().shareSaved) : config().storageError);
    }
    if (event.target.closest('[data-pb44-share-back]')) {
      shared = null;
      shareLoad++;
      refresh();
      setStatus('');
    }
    const arrow = event.target.closest('[data-pb26-scroll]');
    if (arrow) {
      const grid = arrow.closest('.pb26-products')?.querySelector('[data-pb26-slider]');
      grid?.scrollBy({left: grid.clientWidth * Number(arrow.dataset.pb26Scroll), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    for (const current of [dialog(), prompt()]) {
      if (current && event.target === current) {
        const rect = current.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(current);
      }
    }
  });
  function bindDialogs() {
    for (const current of [dialog(), prompt()]) {
      if (!current || current.dataset.pb44Bound) continue;
      current.dataset.pb44Bound = 'true';
      current.addEventListener('close', () => {
        if (!document.querySelector('dialog[open]')) openers.get(current)?.focus?.({preventScroll: true});
      });
    }
  }
  window.addEventListener('storage', event => {
    if (event.key === key || event.key === null) {
      saved = readSaved(event.newValue);
      refresh();
    }
    if (event.key === promptKey) promptSeen = Number(event.newValue) > Date.now() - 30 * 86400000;
  });
  window.addEventListener('hashchange', loadSelection);
  document.addEventListener('shopify:section:load', () => { bindDialogs(); refresh(); });
  document.addEventListener('postbus:products-loaded', refresh);
  bindDialogs();
  refresh();
  loadSelection();
})();
